import axios from 'axios';
// 随机字符串
import getRandVal from '@/assets/js/index'
// 加密
import { identityAuth } from '@/assets/js/url.js';

function getPwdHash(){
    return axios({
        url:identityAuth,
        method:"get",
        headers:{
            "self-flag":"gdlion-sdfl19sfsds",
            "timestamp":(new Date()).getTime()
        }
    })
}
export default function Axios({type, url, obj}){
    return getPwdHash().then((res) => {
        let data;
        const randVal = getRandVal();
        const loginData = JSON.parse(localStorage.getItem('loginData'));
        if(!loginData) { //未登陆
            data = {
                loginName: obj.user,
                appCode:"runWatchScreen",
                // randVal: randVal,
                pwdHash: res.data.data.token,
                userToken: obj.password.toString(),
                token: randVal,
                params: {}
            };
            window.localStorage.setItem('randVal_token',randVal);
        }else{
            data = {
                loginName: JSON.parse(localStorage.getItem('loginData')).loginName,
                appCode:"runWatchScreen",
                // randVal: randVal,
                pwdHash: res.data.data.token,
                userToken: localStorage.getItem('hashValue').toString(),
                token: window.localStorage.getItem('randVal_token'),
                params: {}
            };
            if(obj) {
              if(type == 'put' || url=="/mcbw/cameras/hik/stream_media"){
                data.commitData = {}
                for (let i = 0; i < Object.keys(obj).length; i++) {
                  if (url=="/mcbw/host_parts/update_disk" || url=="/mcbw/fire_control_hosts/control" || url=="/mcbw/message_center/handle") {
                    data.params[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
                  } else {
                    data.commitData[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
                  }
                }
              }else{
                for (let i = 0; i < Object.keys(obj).length; i++) {
                  data.params[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
                }
              }
            }
            // }//合并请求数据
            // if(Object.keys(obj).length){
            //     Object.keys(obj).forEach((item)=>{
            //         console.log(obj[item]);
            //         data.params[obj[item]] = obj[item];
            //     });
            // }else{
            //     delete data.params;
            // }
        }

        // return new Promise((resolve, reject)=>{
        //     console.log(data);
        //     axios[type](url, {params: data}).then((res)=>{
        //         resolve(res);
        //     });
        // });
        return new Promise((resolve, reject)=>{
            // console.log(type);
            switch (type) {
                case 'get':
                    if(url == "/as/third_auth/token/third") {
                        let header = {
                            "self-flag":"gdlion-sdfl19sfsds",
                            "timestamp":(new Date()).getTime()
                          }
                        axios.get(url, {headers:header,params:data}).then((res)=>{
                            resolve(res);
                        }).catch((res)=>{
                            reject(res)
                        });
                    } else {
                        axios.get(url, {params:data}).then((res)=>{
                            resolve(res);
                        }).catch((res)=>{
                            reject(res)
                        });
                    }
                    break;
                case 'delete':
                    axios.delete(url, {params:data}).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
                case 'post':
                    axios.post(url, data).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
                case 'put':
                    axios.put(url, data).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
                case 'patch':
                    axios.patch(url, data).then((res)=>{
                        resolve(res);
                    }).catch((res)=>{
                        reject(res)
                    });
                    break;
            }
        });
    })

}


// WEBPACK FOOTER //
// ./src/assets/js/axios.js